import { useState } from 'react';
import { fetchCitiesByPattern } from '../services/subscriptionRequests';
import useSubscription from './useSubscription';

const PATTERN_LENGTH = 3;

export default function useCities(full = false) {
  const [cities, setCities] = useState<Cities | null>(null);
  const [pattern, setPattern] = useState<string | null>(null);
  const { subscriptionIdIri } = useSubscription();

  const searchPattern = async (pattern: string) => {
    //replace all spaces by - before request
    const pat = pattern.trim().replace(/\s/g, '-');
    setPattern(pat ?? null);

    if (pat.length >= PATTERN_LENGTH && !full) {
      const result = await fetchCitiesByPattern(subscriptionIdIri ?? null, pat);

      setCities(result);
    }
  };

  return { cities, searchPattern, pattern, setPattern };
}
